import React from 'react';
import { Row, Col, Space } from 'antd';
import ResumeRadarIndividual from '../../graphics/resumeRadarIndividual';

const IndividualGlobalResults = ({ individualResult, totalResults }) => {
    const dimensions = Object.entries(individualResult?.average_by_dimension || {})
        .filter(([key, _]) => !key.toLowerCase().includes("general"))
        .map(([_, value]) => value);

    const dimensionsTotals = Object.entries(totalResults?.average_by_dimension || {})
        .filter(([key, _]) => !key.toLowerCase().includes("general"))
        .map(([_, value]) => value);

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Row gutter={[16, 16]} align="stretch" style={{ position: 'relative' }}>
                {/* Etiqueta fija */}
                <span
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: 200,
                        color: '#339C98',
                        fontWeight: 500,
                        fontSize: 20,
                        zIndex: 1,
                    }}
                >
                    Modelo de Liderazgo
                </span>

                <Col xs={24} md={24} >
                    <ResumeRadarIndividual
                        dimensions={dimensions}
                        dimensionsTotals={dimensionsTotals}
                    />
                </Col>
            </Row>
        </Space>

    );
};

export default IndividualGlobalResults;
